import { get } from 'lodash'

import Api from 'common/api'

import types from './types'

const USER_URL = '/api/user'
const AVATAR_URL = '/api/user/avatar'
const PROFILE_URL = '/api/student/profile'

const dispatchedFetchUser = (dispatch) => {
  dispatch({
    type: types.FETCH_USER_START,
  })
  return Api.get(USER_URL)
    .then((user) => {
      dispatch({
        type: types.FETCH_USER_SUCCESS,
        payload: user,
      })
    })
    .catch(() => {
      dispatch({
        type: types.FETCH_USER_FAILURE,
      })
    })
}

const fetchUser = () => {
  return dispatchedFetchUser
}

const updateUser = (newUser) => {
  return (dispatch) => {
    dispatch({
      type: types.UPDATE_USER_START,
    })
    return Api.put(USER_URL, newUser)
      .then(() => {
        dispatch({
          type: types.UPDATE_USER_SUCCESS,
        })
        return dispatchedFetchUser(dispatch)
      })
      .catch((err) => {
        dispatch({
          type: types.UPDATE_USER_FAILURE,
        })
        return Promise.reject(err)
      })
  }
}

const alterUser = (newUserSubset) => {
  return (dispatch, getState) => {
    const user = getState().user.record
    const newUser = {
      ...user,
      ...newUserSubset,
    }
    dispatch({
      type: types.ALTER_USER_START,
    })
    return Api.patch(USER_URL, user, newUser)
      .then(() => {
        dispatch({
          type: types.ALTER_USER_SUCCESS,
        })
        return dispatchedFetchUser(dispatch)
      })
      .catch((response = {}) => {
        dispatch({
          type: types.ALTER_USER_FAILURE,
        })
        if (response.status === 422) {
          dispatchedFetchUser(dispatch)
        }
        return Promise.reject()
      })
  }
}
const updateProfile = (profile) => {
  return (dispatch) => {
    dispatch({
      type: types.UPDATE_PROFILE_START,
    })
    return Api.post(PROFILE_URL, profile)
      .then(() => {
        dispatch({
          type: types.UPDATE_PROFILE_SUCCESS,
          payload: profile,
        })
      })
      .catch((err) => {
        dispatch({
          type: types.UPDATE_PROFILE_FAILURE,
        })
        return Promise.reject(err)
      })
  }
}
const updateAvatar = (fileKey) => {
  return (dispatch) => {
    var avatarInfo = {
      Bucket: window.FILE_STACK_BUCKET,
      Object: fileKey,
    }
    dispatch({
      type: types.UPDATE_AVATAR_START,
    })
    return Api.put(AVATAR_URL, avatarInfo)
      .then(() => {
        dispatch({
          type: types.UPDATE_AVATAR_SUCCESS,
        })
        return dispatchedFetchUser(dispatch)
      })
      .catch(() => {
        dispatch({
          type: types.UPDATE_AVATAR_FAILURE,
        })
        return Promise.reject()
      })
  }
}

const registeredAbandonedScid = (scid) => (dispatch, getState) => {
  const user = getState().user.record
  const payload = { ...get(user, 'AbandonedScids'), [scid]: true }
  return dispatch({
    type: types.REGISTER_ABANDONED_SCID,
    payload,
  })
}

const actions = {
  fetchUser,
  updateUser,
  alterUser,
  updateProfile,
  updateAvatar,
  registeredAbandonedScid,
}

export default actions
